import { z } from 'zod'

export const sourceTagsResponseSchema = z.object({
  result: z.array(z.string()),
})

export type FetchExchangeSourceTagsResponse = z.infer<typeof sourceTagsResponseSchema>
